var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAyushchairsIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 65,
    viewBox: "0 0 57 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.6379 40.7024L28.5 52.8131L16.3621 40.7024C7.26496 41.0959 0 48.5223 0 57.6879V58.9065C0 62.2706 2.73549 65 6.10714 65H50.8929C54.2645 65 57 62.2706 57 58.9065V57.6879C57 48.5223 49.735 41.0959 40.6379 40.7024ZM1.73036 10.1335L2.54464 10.324V17.7377C1.65402 18.2708 1.01786 19.1975 1.01786 20.3147C1.01786 21.381 1.60313 22.2697 2.43013 22.8155L0.445313 30.7243C0.229018 31.6003 0.7125 32.5016 1.41228 32.5016H6.73058C7.43036 32.5016 7.91384 31.6003 7.69755 30.7243L5.71272 22.8155C6.53973 22.2697 7.125 21.381 7.125 20.3147C7.125 19.1975 6.48884 18.2708 5.59821 17.7377V11.0603L13.9955 13.0787C12.9013 15.2622 12.2143 17.6996 12.2143 20.3147C12.2143 29.2898 19.5047 36.5639 28.5 36.5639C37.4953 36.5639 44.7857 29.2898 44.7857 20.3147C44.7857 17.6996 44.1114 15.2622 43.0045 13.0787L55.2569 10.1335C57.5725 9.57497 57.5725 6.69328 55.2569 6.13471L31.0319 0.295152C29.3779 -0.0983839 27.6348 -0.0983839 25.9808 0.295152L1.73036 6.12202C-0.572545 6.68058 -0.572545 9.57497 1.73036 10.1335Z",
    fill: "#5D5D5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAyushchairsIco);
export default __webpack_public_path__ + "static/media/ayushchairs-ico.6d13aa84496988ff4d923d0e9b0a833a.svg";
export { ForwardRef as ReactComponent };